// extracted by mini-css-extract-plugin
export var header = "_tz-1";
export var maskBottom = "_tz-6";
export var maskMiddle = "_tz-7";
export var maskTop = "_tz-5";
export var root = "_tz-0";
export var scrollDownButton = "_tz-3";
export var scrollDownButtonHidden = "_tz-4";
export var viewport = "_tz-2";